import React from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
// import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

const ToggleableLink = (props) => {
  const { disabled, value, ...rest } = props;
  return disabled ? (
    <div
      className="btn btn-light rounded-pill"
      style={{ pointerEvents: "none", opacity: "0.8" }}
      disabled
    >
      {props.children}
    </div>
  ) : (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip style={{ zIndex: 999999999999 }} {...props}>
          Descriptores de la función
        </Tooltip>
      }
    >
      <Link
        {...rest}
        className="btn btn-light px-2 rounded-circle d-flex flex-wrap justify-content-center align-items-center"
        style={{ textDecoration: "none" }}
        to={`/descriptores-perfiles/seleccion-del-descriptor/${
          value && value.id ? value.id : ""
        }/${value && value.descripcion ? value.descripcion : ""}`}
        // target="_blank"
      >
        {props.children}
      </Link>
    </OverlayTrigger>
  );
};

const LinkDescriptor = (props) => {
  //*states
  // const [loader, setLoader] = useState(false);
  return (
    <ToggleableLink
      value={props.value}
      disabled={props.loader && props.value === props.functionSelected}
    >
      {props.loader && props.value === props.functionSelected ? (
        <Spinner
          className="ml-2"
          animation="border"
          variant="primary"
          size="sm"
        />
      ) : (
        <i className="material-icons">description</i>
      )}
    </ToggleableLink>
  );
};

export default LinkDescriptor;
